const menu = "_menu_19sse_8";
const title = "_title_19sse_74";
const styles = {
  menu,
  title
};
export {
  styles as default,
  menu,
  title
};
//# sourceMappingURL=FloatingMenu.module.css.js.map
